package fr.frux.core.common.directions

import fr.frux.core.common.logging.Logger
import kotlinx.browser.window

private const val TAG = "DirectionsLauncher"

/**
 * `window.open` dans un nouvel onglet plutôt qu'une navigation in-place : ne quitte pas Frux, sur
 * le même principe que les liens externes du reste de l'app web.
 *
 * La fenêtre rendue est nulle quand le navigateur a bloqué l'ouverture (bloqueur de pop-ups sur un
 * clic qu'il ne juge pas assez direct). C'est le seul échec observable ici, et le tester vaut mieux
 * qu'un catch : `window.open` ne lève pas dans ce cas.
 */
private object JsDirectionsLauncher : DirectionsLauncher {
    override fun openDirections(
        latitude: Double,
        longitude: Double,
        label: String,
    ): Boolean {
        val opened = window.open(buildGoogleMapsUrl(latitude, longitude), target = "_blank")
        if (opened == null) {
            Logger.e(TAG, "Ouverture de l'itinéraire bloquée par le navigateur")
        }
        return opened != null
    }
}

actual fun createDirectionsLauncher(): DirectionsLauncher = JsDirectionsLauncher
